(() => {
  const values = (s) => (s || '').split('|').map((s) => s.trim()).filter(Boolean);
  const normalized = (s) => (s || '').normalize('NFKC').toLocaleLowerCase('ja');
  const initialize = (root) => {
    if (!root || root.dataset.peopleReady === 'true') return;
    const grid = root.querySelector('[data-people-grid]');
    const areaButtons = [...root.querySelectorAll('[data-people-area]')];
    const region = root.querySelector('[data-people-region]');
    const search = root.querySelector('[data-people-search]');
    const result = root.querySelector('[data-people-result]');
    const empty = root.querySelector('[data-people-empty]');
    const reset = root.querySelector('[data-people-reset]');
    const loading = root.querySelector('[data-people-loading]');
    const error = root.querySelector('[data-people-load-error]');
    const fallback = root.querySelector('[data-people-load-fallback]');
    const pagination = root.querySelector('[data-people-pagination]');
    if (!grid || !region || !search || !result || !empty) return;
    root.dataset.peopleReady = 'true';

    const params = new URLSearchParams(window.location.search);
    let selectedArea = ['all', 'tajima', 'tango'].includes(params.get('type')) ? params.get('type') : 'all';
    let selectedRegion = params.get('region') || '';
    search.value = params.get('q') || '';
    let cards = [];

    const updateChoices = () => {
      const options = new Set();
      cards.forEach((card) => values(card.dataset.regions).forEach((v) => options.add(v)));
      region.replaceChildren();
      region.add(new Option('すべての地域', ''));
      [...options].sort((a, b) => a.localeCompare(b, 'ja'))
        .forEach((item) => region.add(new Option(item, item)));
      if (selectedRegion && !options.has(selectedRegion)) region.add(new Option(selectedRegion, selectedRegion));
      region.value = selectedRegion;
    };
    const update = (saveUrl = false) => {
      const needle = normalized(search.value.trim());
      let found = 0;
      cards.forEach((card) => {
        const types = card.dataset.area === 'both' ? ['tajima', 'tango'] : [card.dataset.area];
        const visible = (selectedArea === 'all' || types.includes(selectedArea)) &&
          (!selectedRegion || values(card.dataset.regions).includes(selectedRegion)) &&
          (!needle || normalized(card.dataset.search).includes(needle));
        card.hidden = !visible;
        if (visible) found++;
      });
      areaButtons.forEach((button) => {
        const active = button.dataset.peopleArea === selectedArea;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('is-active', active);
      });
      const waiting = root.dataset.peopleLoading === 'true';
      result.textContent = `${found}名を表示中${waiting ? '（ほかの記事を確認中）' : ''}`;
      empty.hidden = found > 0 || cards.length === 0 || waiting;
      if (reset) reset.hidden = selectedArea === 'all' && !selectedRegion && !needle;
      if (saveUrl && !new URLSearchParams(window.location.search).has('page')) {
        const url = new URL(window.location.href);
        for (const key of ['type', 'region', 'field', 'q']) url.searchParams.delete(key);
        if (selectedArea !== 'all') url.searchParams.set('type', selectedArea);
        if (selectedRegion) url.searchParams.set('region', selectedRegion);
        if (search.value.trim()) url.searchParams.set('q', search.value.trim());
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
    };
    const refresh = () => {
      cards = [...grid.querySelectorAll('[data-people-card]')];
      updateChoices();
      update();
    };
    areaButtons.forEach((button) => button.addEventListener('click', () => {
      selectedArea = button.dataset.peopleArea;
      update(true);
    }));
    region.addEventListener('change', () => { selectedRegion = region.value; update(true); });
    search.addEventListener('input', () => update(true));
    if (reset) reset.addEventListener('click', () => {
      selectedArea = 'all';
      selectedRegion = '';
      search.value = '';
      region.value = '';
      update(true);
    });
    refresh();

    let next = root.querySelector('[data-people-next]')?.href || null;
    if (!next) return;
    if (pagination) pagination.hidden = true;
    root.dataset.peopleLoading = 'true';
    if (loading) loading.hidden = false;
    update();
    (async () => {
      const seen = new Set([window.location.href]);
      try {
        while (next && !seen.has(next)) {
          seen.add(next);
          const response = await fetch(next, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Page ${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const remote = doc.querySelector('[data-people-directory]');
          if (!remote) throw new Error('People directory absent from paginated response');
          const remoteCards = [...remote.querySelectorAll('[data-people-card]')];
          if (!remoteCards.length) throw new Error('No more cards');
          const fragment = document.createDocumentFragment();
          remoteCards.forEach((card) => fragment.append(card));
          grid.append(fragment);
          next = remote.querySelector('[data-people-next]')?.href || null;
          refresh();
        }
      } catch (e) {
        if (error) error.hidden = false;
        if (fallback && next) fallback.href = next;
        if (pagination) pagination.hidden = false;
      } finally {
        root.dataset.peopleLoading = 'false';
        if (loading) loading.hidden = true;
        update();
      }
    })();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-people-directory]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-people-story]').forEach((story) => {
    if (story.dataset.peopleStoryReady === 'true') return;
    story.dataset.peopleStoryReady = 'true';
    const content = story.querySelector('[data-people-story-body]');
    const toc = story.querySelector('[data-people-toc]');
    const list = story.querySelector('[data-people-toc-list]');
    if (!content || !toc || !list) return;
    const headings = [...content.querySelectorAll('h2')].filter((h) => h.textContent.trim() && !h.closest('.tajima-story-profile'));
    if (headings.length < 3) return;
    headings.forEach((h, i) => {
      if (!h.id) h.id = `people-story-${i + 1}`;
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${h.id}`;
      link.textContent = h.textContent.trim();
      li.append(link);
      list.append(li);
    });
    toc.hidden = false;
    list.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const id = decodeURIComponent(link.getAttribute('href').slice(1));
      const destination = headings.find((heading) => heading.id === id);
      if (!destination) return;
      event.preventDefault();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destination.setAttribute('tabindex', '-1');
      destination.focus({ preventScroll: true });
      if (window.matchMedia('(min-width: 768px)').matches) {
        const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ks-pc-anchor-offset')) || 98;
        const top = Math.max(0, window.scrollY + destination.getBoundingClientRect().top - offset);
        window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
      } else {
        destination.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      }
      window.history.replaceState(null, '', '#' + encodeURIComponent(id));
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
